<!-- <mat-label class="subHeading"
  >Registration Number<span *ngIf="isRequired" class="star">*</span></mat-label
> -->
<mat-form-field appearance="outline" [class]="registrationNumber">
  <mat-label>Enter Registration Number</mat-label>
  <input
    id-automation="registrationNumberId"
    matInput
    placeholder="DL-01-AB-1234"
    formControlName="registration_number"
    id-automation="registration_number"
    [(ngModel)]="inputValue"
    [(ngModel)]="registrationNumber"
    (input)="onInputChange()"
    appRegistrationNumber
    maxlength="14"
    [ngClass]="{
      isRegistrationNumber: isRegistrationNumber
    }"
    class="uppercase-input"
  />
  <mat-error *ngIf="form.controls['registration_number']?.hasError('required')">
    This is a required field.
  </mat-error>
  <mat-error *ngIf="form.get('registration_number')?.hasError('minlength')">
    Minimum length 8
  </mat-error>

  <mat-error *ngIf="form.get('registration_number')?.hasError('maxlength')">
    Max Length 11
  </mat-error>
  <mat-error *ngIf="form.get('registration_number')?.hasError('pattern')">
    Invalid Registration Number
  </mat-error>
  <!-- <mat-error *ngIf="form.controls['registration_number'].invalid && form.controls['insurer_email'].touched">
  Invalid Email Format
</mat-error> -->
</mat-form-field>
